import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { CrossSellProductActions } from '../constants/cross_sell_product/cross_sell_product_actions';

class CrossSellProductStoreClass extends ReduceStore {
  getInitialState() {
    return [];
  }

  reduce(state, { source, action }) {
    const { type, payload } = action;

    if (source !== ACTION_TYPES.CROSS_SELL_PRODUCTS_ACTION) {
      return state;
    }

    switch (type) {
      case CrossSellProductActions.SET_PRODUCT:
        state = payload;
        break;

      case CrossSellProductActions.ADD_PRODUCT:
        state = [...state, payload];
        break;

      case CrossSellProductActions.REMOVE_PRODUCT:
        state = state.filter((product) => product.spinachId !== payload);
        break;

      case CrossSellProductActions.UPDATE_PRODUCT:
        state = state.map((product) => {
          if (product.spinachId === payload.spinachId) {
            return {
              ...product,
              ...payload,
            };
          }

          return product;
        });
    }

    return state;
  }
}

const CrossSellProductStore = new CrossSellProductStoreClass(Dispatcher);
export { CrossSellProductStore };
